import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import EmailEntity from '@/entities/api/mail/mail'

export const sendEmail = async (email: EmailEntity, token: string) => {
	const response = await axios.post(`${API_URL}/email`, email, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

